<template>
	<div class="scollTop" v-show="showBox" @click="scrollTopFn">
		<img src="../../../static/img/myCenter/top@2x.png">
	</div>
</template>
<script>

export default {
	name: 'scrollTop',
	data () {
		return {
			showBox: false,
			scrollA: null,
			nowTop: 0,
		}
	},
	methods: {
		getScrollTop: function () {
			var scrollTop = 0;
			if (document.documentElement && document.documentElement.scrollTop) {
				scrollTop = document.documentElement.scrollTop;
			}
			else if (document.body) {
				scrollTop = document.body.scrollTop;
			}
			return scrollTop;
		},
		scrollTopFn: function () {
			var _self = this;
			this.scrollA = setInterval(function () {
				_self.nowTop -= 50;
				window.scrollTo(0, _self.nowTop);
				if (_self.nowTop < 1) {
					clearInterval(_self.scrollA);
				}
			}, 10)
		}
	},
	mounted () {
		var _this = this, nowTop;
		window.addEventListener("scroll", function () {
			_this.nowTop = parseInt(_this.getScrollTop());
			_this.showBox = _this.nowTop > 800 && true || false;
		});

	},
	computed: {
	}

}
</script>
<style lang="scss">
.scollTop {
  position: fixed;
  z-index: 1999;
  width: 1.9rem;
  height: 1.9rem;
  right: 0.5rem;
  bottom: 3rem;
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// scrollTop.vue?52a1ff99